<template>
    <!-- 头部 -->
    <div class="top_header">
        <!-- 左 -->
        <div class="left flex">
            <div>
                {{deptName}}
            </div>
        </div>
        <!-- 中 -->
        <div class="title">
            <img
                class="font"
                src="../assets/images/logo.png"
                alt=""
            >
            <div>广东省廉餐食堂信息公示平台</div>
        </div>
        <!-- 右 -->
        <div class="right">
            <div class="right-addres">
                <div class="data-time">
                    <div class="time">{{time}}</div>
                </div>
                <div>
                    {{weekValue}}
                </div>
                <!-- 缩放全屏 -->
                <!-- <div
                    class="scaling"
                    @click="onClickScale"
                >
                    <img
                        class="scal_icon"
                        :src="!zoomState ? scaleAll : scaleSmall"
                        alt
                    />
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { handleTime, formatTime, getWeek } from "@/assets/js/common";
import { fullscreenToggel, listenfullscreen, fullscreenEnable } from "@/assets/js/fullscreen"; //全屏方法
export default {
    name: 'headerPage',
    computed: {},
    data() {
        return {
            time: '', // 时间
            weekValue: '',
            // 星期
            weekArr: [ "星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六" ],
            deptName: '',
            deptId: '',
            zoomState: JSON.parse(localStorage.getItem('zoomState')),
            scaleAll: require('@/assets/images/icon_quanping.png'),
            scaleSmall: require('@/assets/images/icon_fanhui.png')
        }
    },
    watch: {
        $route(to) {
            console.log(to, 'url值改变')
            if (Object.keys(to.query).length > 0) {
                let did = to.query.id;
                this.deptId = !did ? localStorage.getItem('deptId') : did;
                this.deptName = ''
                this.getCanteenDisplay()
            } else {
                this.deptId = ''
            }
        }
    },
    methods: {
        // 全屏
        onClickScale() {
            listenfullscreen(true); // esc监听全屏
            fullscreenToggel(); // 全屏
            this.zoomState = JSON.parse(localStorage.getItem('zoomState'))
        },
        // 获取当天星期几
        week() {
            let times = formatTime(new Date(), 'yyyy-MM-dd')
            let week = getWeek(times)
            return week
        },
        /**
         * @function getCanteenDisplay 食堂名称
         * @param deptId 食堂id
         */
        getCanteenDisplay() {
            this.$get(this.$api.getCanteenDisplay, {
                deptId: this.deptId
            }).then(res => {
                console.log('食堂名称-res', res)
                const { code, success, data } = res
                if (code == 200 && success) {
                    this.deptName = data.deptName
                }
            }).catch(err => {
                // this.$message.error(err.message);
                console.log('食堂名称-err', err)
            })
        }
    },
    created() {
        this.deptId = localStorage.getItem('deptId')
        //  this.deptId ='1466336161432678401'
        //获取星期
        this.weekValue = this.week()
        this.getCanteenDisplay()
    },
    mounted() {
        setInterval(() => {
            this.time = handleTime()
            this.weekValue = this.week()
        }, 1000);
        let _that = this
        window.onresize = function temp() { // 监听窗口变动
            if (!fullscreenEnable()) {
                localStorage.setItem('zoomState', false)
                _that.zoomState = JSON.parse(localStorage.getItem('zoomState'))
            }
        };
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="scss" scoped>
.top_header {
    @include flex(space-between);
    height: vh(131);
    font-size: vh(24);
    padding: 0 vh(68);
    line-height: vh(66);
    .left {
        font-size: vh(24);
        color: #3ceaff;
        line-height: vh(75);
        img {
            width: vh(46);
            height: vh(69);
            margin-right: vh(20);
        }
    }
    .right {
        .right-addres {
            @include flex(flex-end);
            .data-time {
                line-height: vh(78);
                text-align: center;
                margin-right: vh(20);
                @include flex(flex-start);
                .time {
                    font-size: vh(24);
                    color: $time_color;
                }
            }
            color: $time_color;
            .scaling > img {
                width: vh(30);
                margin-left: vh(10);
            }
        }
    }
    .left,
    .right {
        width: 25%;
        align-self: flex-end;
    }
    .title {
        display: flex;
        justify-content: center;
        font-size: vh(50);
        color: #00fcff;
        text-align: center;
        font-weight: bold;
        padding-bottom: vh(20);
        img {
            width: vh(46);
            height: vh(69);
            margin: 0 vh(30) vh(6) 0;
            vertical-align: middle;
        }
    }
}
</style>
